import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { CartDrawer } from './components/CartDrawer';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { SearchModal } from './components/SearchModal';
import { CommerceProvider } from './contexts/CommerceContext';
import { AccountPage } from './pages/AccountPage';
import { AdminPage } from './pages/AdminPage';
import { AuthPage } from './pages/AuthPage';
import { CatalogPage } from './pages/CatalogPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { HomePage } from './pages/HomePage';
import { PaymentReturnPage } from './pages/PaymentReturnPage';
import { ProductPage } from './pages/ProductPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior }); }, [pathname]);
  return null;
}

function Storefront() {
  const [searchOpen, setSearchOpen] = useState(false);
  return <><ScrollToTop /><Header onSearch={() => setSearchOpen(true)} /><SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} /><CartDrawer /><Routes><Route path="/" element={<HomePage />} /><Route path="/fitness" element={<CatalogPage forcedCollection="fitness" />} /><Route path="/fitness/:subcategory" element={<CatalogPage forcedCollection="fitness" />} /><Route path="/moda-praia" element={<CatalogPage forcedCollection="moda-praia" />} /><Route path="/lingerie" element={<CatalogPage forcedCollection="lingerie" />} /><Route path="/novidades" element={<CatalogPage mode="novidades" />} /><Route path="/mais-vendidos" element={<CatalogPage mode="mais-vendidos" />} /><Route path="/produto/:slug" element={<ProductPage />} /><Route path="/favoritos" element={<FavoritesPage />} /><Route path="/checkout" element={<CheckoutPage />} /><Route path="/checkout/retorno" element={<PaymentReturnPage />} /><Route path="/entrar" element={<AuthPage />} /><Route path="/minha-conta" element={<AccountPage />} /><Route path="/admin" element={<AdminPage />} /><Route path="*" element={<CatalogPage forcedCollection="fitness" />} /></Routes><Footer /></>;
}

export default function App() {
  return <BrowserRouter><CommerceProvider><Storefront /></CommerceProvider></BrowserRouter>;
}
